<template>
  <json-crud :data-source="dataSource" :headers="headers" :title-field="titleField" :title="$t('forms')" />
</template>

<script>
import JsonCrud from '@/organisms/JsonCRUD.vue';
import FormConfiurationApi from '@/api/FormApi';

const formConfApi = new FormConfiurationApi();
export default {
  name: 'FormConfigurations',
  components: { JsonCrud },
  data() {
    return {
      dataSource: {},
      headers: [{ text: 'id', value: 'id' }],
      titleField: 'id',
    };
  },
  created() {
    this.dataSource = formConfApi;
  },
};
</script>
